// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3pnBi","colMin":"styles_colMin__2L8AR"};